module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiMwMGNiZmYiIGQ9Ik0wIDBoNTExLjk5M3Y1MTEuOTg0SDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAxOTEuOTloNTExLjk5M3YxMjguMDAySDB6Ii8+CiAgICA8cGF0aCBkPSJNMCAyMTIuNjc1aDUxMS45OTN2ODYuNDM4SDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/bw.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/bw.svg
// module chunks = 0